// @flow strict
import { type Node } from 'react'

export const URLS = {
  HOMEPAGE: 'https://www.monzo.com',
  DOWNLOAD_PAGE: 'https://www.monzo.com/download',
  ADJUST_APP_STORE:
    'https://app.adjust.com/ydi27sn?engagement_type=fallback_click&fallback=https://monzo.com/download&redirect_macos=https://monzo.com/download',
  ADJUST_PLAY_STORE:
    'https://app.adjust.com/9mq4ox7?engagement_type=fallback_click&fallback=https://monzo.com/download&redirect_macos=https://monzo.com/download',
  ADJUST_BOTH_STORE:
    'https://app.adjust.com/ydi27sn_9mq4ox7?engagement_type=fallback_click&fallback=https://monzo.com/download&redirect_macos=https://monzo.com/download',
  FACEBOOK: 'https://www.facebook.com/monzobank',
  INSTAGRAM: 'https://www.instagram.com/monzo/',
  TWITTER: 'https://twitter.com/monzo',
  LINKEDIN: 'https://www.linkedin.com/company/monzo-bank',
}

export const APP_IDS = {
  PRODUCTION_GOOGLE_ANALYTICS: 'UA-63104269-1',
  TESTING_GOOGLE_ANALYTICS: 'UA-63104269-4',
}

export type WithChildren = {
  children?: Node,
}
